import { Flex, Text } from '@chakra-ui/react';
import { IJournalWiseUserRoleList } from '@publishing-engine/domain/models';

type IPropsType = {
  data: Array<IJournalWiseUserRoleList>;
};

function UserItem({ data }: IPropsType) {
  if (!data?.length) return <>N/A</>;

  return (
    <Flex flexDirection="column">
      {data.map((d, index) => (
        <Flex
          gap={2}
          key={index}
          alignItems="flex-start"
          flexDirection="column"
        >
          <Flex gap={2}>
            <Text textStyle="headingItem" textTransform="uppercase">
              {'shortname' in d && d.shortname}:
            </Text>
            <Text
              textStyle="textBody"
              textTransform="capitalize"
            >{`${d.roles.join(', ')}`}</Text>
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
}

export default UserItem;
